/**
 * Initialize all ERP integrations
 * Call this once during app startup to ensure all cross-module integrations are active
 */

import { initializeSubcontractingIntegrations, checkIntegrationHealth } from './integrations';

/**
 * Initialize all ERP system integrations
 * This should be called once during app startup, preferably in main.tsx or App.tsx
 */
export const initializeERPIntegrations = () => {
  console.log('🚀 Initializing ERP system integrations...');
  
  try {
    // Initialize subcontracting integrations
    initializeSubcontractingIntegrations();
    
    // Perform health check
    const health = checkIntegrationHealth();
    
    if (health.healthy) {
      console.log('✅ All ERP integrations initialized successfully');
      console.log(`📊 Total event listeners registered: ${health.listeners.length}`);
    } else {
      console.warn('⚠️ Some integrations may not be fully initialized');
    }
    
    return true;
  } catch (error) {
    console.error('❌ Failed to initialize ERP integrations:', error);
    return false;
  }
};

/**
 * Development helper to check integration status
 */
export const logIntegrationStatus = () => {
  console.log('🔍 Integration Status Check:');
  const health = checkIntegrationHealth();
  
  if (health.listeners.length === 0) {
    console.log('❌ No event listeners registered - integrations may not be initialized');
  } else {
    console.log('✅ Integration listeners:');
    health.listeners.forEach(({ type, count }) => {
      console.log(`   - ${type}: ${count} listener(s)`);
    });
  }
  
  return health;
};
